// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let BrandingRulesRequestMessage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_BRANDING_RULES_REQ
    PFixMessage.call(this, fieldSet)
}

BrandingRulesRequestMessage.prototype = Object.create(PFixMessage.prototype)

BrandingRulesRequestMessage.prototype.setBrandingKey = function (brandingKey)
{
    this.setFieldValue(FieldsFactory.FIELD_KEY, brandingKey);
}